var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.windowWidth > 1024)?_c('div',{staticClass:"girl-pet-img-wrapper"},[_c('img',{attrs:{"src":require("@/assets/girl-and-pet.svg")}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }